const rows = [
  {
    name: "Dev Cubix",
    description: "Expert-driven & committed to higher quality. Full-stack team with 24/7 support without hiring in-house employees.",
    scores: [true, true, true, true, true],
    highlighted: true,
  },
  {
    name: "In House Team",
    description: "A full-time designer may ensure brand consistency, but there's a risk of limited expertise even though you pay regularly.",
    scores: [false, false, true, false, true],
    highlighted: false,
  },
  {
    name: "Creative Agencies",
    description: "Agencies offer structured processes but mostly with high costs, long timelines, and less flexibility for your projects.",
    scores: [false, true, true, false, false],
    highlighted: false,
  },
  {
    name: "Freelancers",
    description: "Freelancers may provide affordable design services but they mostly lack consistency, reliability, and collaboration.",
    scores: [true, false, false, false, true],
    highlighted: false,
  },
  {
    name: "Self-Service Tools",
    description: "DIY tools like website builders are budget-friendly, but you can't expect strategic thinking & originality.",
    scores: [true, true, false, false, true],
    highlighted: false,
  },
];

const columns = ["Speed", "Flexibility", "Quality", "Scalability", "Affordability"];

function CheckIcon() {
  return (
    <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-red-accent/20 flex items-center justify-center">
      <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-red-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
      </svg>
    </div>
  );
}

function XIcon() {
  return (
    <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-foreground/5 flex items-center justify-center">
      <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-foreground/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
  );
}

export default function ComparisonTable() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-surface">
      <div className="max-w-[960px] mx-auto px-6">
        <div className="text-center mb-8 md:mb-16">
          <p className="section-badge mb-4 mx-auto">Why Choose Us</p>
          <h2 className="text-2xl sm:text-3xl md:text-[48px] font-bold leading-[1.2] font-ui">
            <span className="font-serif italic text-purple-light">Dev Cubix&apos;s</span>
            <span> Alternative? </span>
            <span className="font-serif italic text-purple-light">Think</span>
            <span> One More Time!</span>
          </h2>
        </div>

        <div className="overflow-x-auto hide-scrollbar">
            {/* Header row */}
            <div className="hidden md:grid grid-cols-[1fr_repeat(5,80px)] gap-4 px-6 py-3 mb-2">
              <div className="text-sm font-medium text-foreground/50">Platform</div>
              {columns.map((col) => (
                <div key={col} className="text-sm font-medium text-foreground/50 text-center">{col}</div>
              ))}
            </div>

            {/* Data rows */}
            {rows.map((row, i) => (
              <div
                key={i}
                className={`hidden md:grid grid-cols-[1fr_repeat(5,80px)] gap-4 px-6 py-5 rounded-2xl mb-2 ${
                  row.highlighted
                    ? "bg-purple/10 border border-purple/30"
                    : "bg-surface-light border border-card-border"
                }`}
              >
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
                      row.highlighted ? "bg-purple text-white" : "bg-foreground/10 text-foreground/50"
                    }`}>
                      {row.name[0]}
                    </div>
                    <span className={`font-semibold text-sm ${row.highlighted ? "text-badge-text" : "text-foreground"}`}>
                      {row.name}
                    </span>
                  </div>
                  <p className="text-xs text-foreground/40 ml-11">{row.description}</p>
                </div>
                {row.scores.map((score, j) => (
                  <div key={j} className="flex items-center justify-center">
                    {score ? <CheckIcon /> : <XIcon />}
                  </div>
                ))}
              </div>
            ))}

            {/* Mobile cards */}
            <div className="md:hidden space-y-3">
              {rows.map((row, i) => (
                <div
                  key={`mobile-${i}`}
                  className={`rounded-2xl p-4 ${
                    row.highlighted
                      ? "bg-purple/10 border border-purple/30"
                      : "bg-surface-light border border-card-border"
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
                      row.highlighted ? "bg-purple text-white" : "bg-foreground/10 text-foreground/50"
                    }`}>
                      {row.name[0]}
                    </div>
                    <span className={`font-semibold text-sm ${row.highlighted ? "text-badge-text" : "text-foreground"}`}>
                      {row.name}
                    </span>
                  </div>
                  <p className="text-xs text-foreground/40 mb-3">{row.description}</p>
                  <div className="grid grid-cols-5 gap-1 sm:gap-2">
                    {columns.map((col, j) => (
                      <div key={j} className="flex flex-col items-center gap-1">
                        {row.scores[j] ? <CheckIcon /> : <XIcon />}
                        <span className="text-[8px] sm:text-[9px] text-foreground/30 truncate max-w-full">{col}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
        </div>
      </div>
    </section>
  );
}
